import { Button, InputAdornment, OutlinedInput } from "@mui/material";
import TopNav from "../components/TopNav";
import splitStyle from "./SplitPage.module.css";
import { ReactNode } from "react";
import { ArrowBack, Search } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";

// One thing on screen at a time: the list, or the record that is open.
// "Back" returns to wherever the record was opened from (for example the
// customer a proposal was started from), or to the list.
function SplitPageView({
  contentList,
  mainContent,
  pageTitle,
  breadcrumbs,
  selected,
  search,
  onSearchChange,
}: {
  contentList: ReactNode;
  mainContent: ReactNode;
  breadcrumbs?: ReactNode;
  pageTitle: string;
  // Whether a record is open (?id=, ?cid= or ?new= is set).
  selected?: boolean;
  search?: string;
  onSearchChange?: (value: string) => void;
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    // React Router counts in-app history entries; only step back inside the
    // app, otherwise show this section's list.
    if ((window.history.state?.idx ?? 0) > 0) {
      navigate(-1);
    } else {
      navigate(location.pathname);
    }
  };

  return (
    <div className={`page ${splitStyle.page}`}>
      <TopNav pageTitle={pageTitle} />
      <main className={splitStyle.split}>
        {selected ? (
          <div className={splitStyle.viewerContainer}>
            <div className={splitStyle.detailHeader}>
              <Button
                startIcon={<ArrowBack />}
                onClick={goBack}
                className={splitStyle.backButton}
              >
                Back
              </Button>
              {breadcrumbs && (
                <div className={splitStyle.breadcrumbs}>{breadcrumbs}</div>
              )}
            </div>
            <div className={splitStyle.viewer}>{mainContent}</div>
          </div>
        ) : (
          <div className={splitStyle.listPane}>
            <div className={splitStyle.listInner}>
              {onSearchChange && (
                <div className={splitStyle.searchBox}>
                  <OutlinedInput
                    size="small"
                    fullWidth
                    placeholder={`Search ${pageTitle.toLowerCase()}`}
                    value={search || ""}
                    onChange={(e) => onSearchChange(e.target.value)}
                    startAdornment={
                      <InputAdornment position="start">
                        <Search fontSize="small" />
                      </InputAdornment>
                    }
                  />
                </div>
              )}
              <div className={splitStyle.listCard}>{contentList}</div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default SplitPageView;
